import { sortPrerequisites } from "utils/standards";
import "components/pages/GroupCodeStandardSearch/groupCodeStandardSearch.css";

export const PREREQ_SECTIONS = [
  {
    level: 1,
    tier: "Primary",
    subtitle: "The adjacent standards that directly support learning the Core Standard.",
  },
  {
    level: 2,
    tier: "Secondary",
    subtitle: "The standards that support learning the primary prerequisite standards.",
  },
  {
    level: 3,
    tier: "Tertiary",
    subtitle: "The standards that support learning the Secondary prerequisite standards.",
  },
];

// Renders {level, standards[]} prerequisite groups as Primary/Secondary/Tertiary
// sections. Each surface supplies its own card via renderCard(standard, index,
// isLast); empty levels are skipped, and entityCode (optional) suffixes the
// section titles ("Primary Prerequisites for 5.G.B.3").
export const PrerequisiteTierSections = ({ groups, entityCode, renderCard }) =>
  PREREQ_SECTIONS.map(({ level, tier, subtitle }) => {
    const grp = (groups || []).find((g) => g.level === level);
    if (!grp?.standards?.length) return null;
    const items = sortPrerequisites(grp.standards);
    return (
      <div key={`prereq-level-${level}`} className="level-group" style={{ background: "transparent" }}>
        <div className="relationships-header">
          <div className="relationships-header-title">
            {tier} Prerequisites{entityCode ? ` for ${entityCode}` : ""}
          </div>
          <div className="relationships-header-subtitle">{subtitle}</div>
        </div>
        <div className="level-group-cards" style={{ background: "transparent", border: "none", borderRadius: 0 }}>
          {items.map((s, i) => renderCard(s, i, i === items.length - 1))}
        </div>
      </div>
    );
  });
